import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MessagesComponent } from './pages/messages/messages.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginGuard } from './guards/login.guard';
import { PagesComponent } from "./pages/pages/pages.component";
import { OrdersComponent } from "./pages/orders/orders.component";
import { StatsComponent } from "./pages/stats/stats.component";
import { ProductsComponent } from  "./pages/products/products.component";
import { UsersComponent } from "./pages/users/users.component";
import { TranslationsComponent } from "./pages/translations/translations.component";

const appRoutes: Routes = [
  { path: '', redirectTo: '/orders/new', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard/:stat', component: StatsComponent, canActivate: [LoginGuard] },
  { path: 'dashboard', component: StatsComponent, canActivate: [LoginGuard] },

  // { path: 'settings', component: SettingsComponent, canActivate: [LoginGuard] },
  { path: 'products', component: ProductsComponent, canActivate: [LoginGuard] },
  { path: 'users', component: UsersComponent, canActivate: [LoginGuard] },

  { path: 'orders/:mode', component: OrdersComponent, canActivate: [LoginGuard] },
  { path: 'translations/:lang', component: TranslationsComponent, canActivate: [LoginGuard] },
  { path: 'translations', component: TranslationsComponent, canActivate: [LoginGuard] },

  { path: 'messages', component: MessagesComponent, canActivate: [LoginGuard] },
  { path: 'pages', component: PagesComponent, canActivate: [LoginGuard] },

  { path: '**', redirectTo: '', component: HomeComponent } // untill we have a decent 404
];

@NgModule({
  imports: [ RouterModule.forRoot(appRoutes, { enableTracing: false }) ],
  exports: [RouterModule],
  providers: [
    LoginGuard
  ]
})



export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/app-routing.module.ts